namespace TabAurous.HR {
    export interface EmployeeQualificationRow {
        QualificationId?: number;
        Code?: string;
        Name?: string;
    }

    export namespace EmployeeQualificationRow {
        export const idProperty = 'QualificationId';
        export const nameProperty = 'Code';
        export const localTextPrefix = 'HR.EmployeeQualification';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            QualificationId = "QualificationId",
            Code = "Code",
            Name = "Name"
        }
    }
}
